<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid user-manager-message">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h6>User Manager</h6>
            <br />

            <b-alert class="alert-class" show dismissible v-if="+userId">
              User {{ getUserDetail.username }} {{ action }}
            </b-alert>
            <router-link
              class="btn btn-primary btn-lg btn-sm-block mr-2"
              :to="{ name: 'AdminUserManagerAddUser' }"
              @click.native="scrollToTop"
            >
              Add User
            </router-link>
            <router-link
              class="btn btn-primary btn-lg btn-sm-block mr-2"
              :to="{ name: 'AdminUserManager' }"
              @click.native="scrollToTop"
            >
              User Manager
            </router-link>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";

export default {
  name: "UserManagerMessage",

  props: {
    activeMenuItem: String,
    activeMenu: String,
    userId: String,
    action: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {};
  },

  computed: {
    getUserDetail() {
      return this.$store.getters["userManager/getUserDetail"];
    },
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersUserManager",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
    this.$store.dispatch("userManager/fetchUserDetailsById", {
      userId: +this.userId,
    });
  },
};
</script>

<style lang="scss" scoped>
.user-manager-message {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 8px;
    border-radius: $border-radius-sm;
  }
}

.alert-class {
  //   background-color: rgba(55, 130, 243, 1);
  border: 2px solid rgba(55, 130, 243, 1);
  color: rgba(55, 130, 243, 1);
}
</style>
